export const WS_MESSAGE         = 'WS_MESSAGE';
export const WS_MESSAGE_BULK    = 'WS_MESSAGE_BULK';
//export const WS_RECONNECTING    = 'WS_RECONNECTING';
export const WS_CONNECTION_LOST = 'WS_CONNECTION_LOST';
//export const WS_RECONNECT       = 'WS_RECONNECT';
export const WS_DISCONNECT      = 'WS_DISCONNECT';
